import { render } from "./ctx-dog-dogs.vue?vue&type=template&id=d4ce8794&scoped=true"
import script from "./ctx-dog-dogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ctx-dog-dogs.vue?vue&type=script&setup=true&lang=js"

import "./ctx-dog-dogs.vue?vue&type=style&index=0&id=d4ce8794&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ce8794"],['__file',"src/views/history/history-card/components/ctx-dog-dogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4ce8794"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4ce8794', __exports__)) {
    api.reload('d4ce8794', __exports__)
  }
  
  module.hot.accept("./ctx-dog-dogs.vue?vue&type=template&id=d4ce8794&scoped=true", () => {
    api.rerender('d4ce8794', render)
  })

}


export default __exports__